import { Alert, List, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useSnapshot } from "valtio";
import { assistantRetentionTexts } from "@/locales/assistant-retention";
import { i18nStore } from "@/store/i18n";
import { retentionBite } from "./retention-rules.logic";

/**
 * Penjelasan dua aturan retensi di grup "Riwayat". `transcriptRetentionDays`
 * datang dari overview server (sumber yang sama dengan job penghapus); bila
 * masih 0 (belum terjawab) aturan transkrip tidak diklaim angkanya.
 */
export function RetentionRulesNote({
	transcriptRetentionDays,
	inactiveRetentionDays,
}: {
	transcriptRetentionDays: number;
	inactiveRetentionDays: number;
}) {
	const { lang: uiLang } = useSnapshot(i18nStore);
	const t = assistantRetentionTexts[uiLang === "en" ? "en" : "id"];
	const bite = retentionBite(transcriptRetentionDays, inactiveRetentionDays);
	if (bite === "unknown") return null;

	return (
		<Alert
			variant="light"
			color="blue"
			icon={<IconInfoCircle size={16} />}
			title={t.title}
			data-retention-rules-note
		>
			<Text size="sm">{t.intro}</Text>
			<List size="sm" type="ordered" mt={4}>
				<List.Item>{t.transcriptRule(transcriptRetentionDays)}</List.Item>
				<List.Item>
					{inactiveRetentionDays > 0
						? t.inactiveRule(inactiveRetentionDays)
						: t.inactiveRuleOff}
				</List.Item>
			</List>
			<Text size="sm" fw={600} mt={6}>
				{bite === "transcript"
					? t.transcriptFirst(transcriptRetentionDays)
					: t.inactiveFirst(inactiveRetentionDays)}
			</Text>
		</Alert>
	);
}
